import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/metajuana-staking-lab.png'
import _imports_1 from '../../assets/closed_capsules.png'
import _imports_2 from '../../assets/opened_capsules.png'
import _imports_3 from '../../assets/germinations_door.png'


const _withScopeId = n => (_pushScopeId("data-v-7b6112e9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mb-10 flex justify-center" }
const _hoisted_2 = { class: "parent" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "background",
  src: _imports_0
}, null, -1))
const _hoisted_4 = { class: "wallet" }
const _hoisted_5 = {
  key: 0,
  class: "capsules"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "capsules",
  src: _imports_1
}, null, -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = {
  key: 1,
  class: "capsules"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "capsules",
  src: _imports_2
}, null, -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "vault" }
const _hoisted_12 = { class: "arrow-buttons" }
const _hoisted_13 = { class: "arrows m-1 flex flex-col" }
const _hoisted_14 = ["href"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", null, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "door_pic",
    src: _imports_3
  })
], -1))
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = { class: "processing" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NFTGrid = _resolveComponent("NFTGrid")!
  const _component_NFTGrid2 = _resolveComponent("NFTGrid2")!
  const _component_ArrowButton = _resolveComponent("ArrowButton")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_NFTGrid, {
          title: "",
          class: "flex-1",
          nfts: _ctx.currentWalletNFTs,
          onSelected: _ctx.handleWalletSelected
        }, null, 8, ["nfts", "onSelected"])
      ]),
      (_ctx.vaultLocked)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
        : (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_10)),
      _createElementVNode("div", _hoisted_11, [
        (_ctx.bank && _ctx.vault)
          ? (_openBlock(), _createBlock(_component_NFTGrid2, {
              key: 0,
              title: "",
              class: "flex-1",
              nfts: _ctx.currentVaultNFTs,
              onSelected: _ctx.handleVaultSelected
            }, null, 8, ["nfts", "onSelected"]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _createVNode(_component_ArrowButton, {
            disabled: _ctx.vaultLocked,
            class: "my-2",
            left: true,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.moveNFTsFE(true)))
          }, null, 8, ["disabled"])
        ])
      ]),
      _createElementVNode("a", {
        href: 'https://curation2d.vercel.app/',
        target: "_blank"
      }, _hoisted_16, 8, _hoisted_14)
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_17, " Processing Transaction... Do not refresh page! ", 512), [
      [_vShow, _ctx.processing === true]
    ])
  ], 64))
}